"use client";

import { convertToAssetId, HydratedTable, Member } from "@zapier/client";
import { TableChangeOwnerModalContainer } from "../TableChangeOwnerModalContainer";
import { TableDeleteModal } from "../TableDeleteModal/TableDeleteModal";
import { TableRenameModal } from "../TableRenameModal";
import { TableShareModal } from "../TableShareModal";
import { useMemo, useState } from "react";
import { MoveAssetModal } from "@zapier/shared";
import { AssetTypes } from "@zapier/utils";
// import { MoveFolderModal } from "@zapier/shared";

export enum TableModal {
  Rename = "table__rename",
  Delete = "table__delete",
  ChangeOwner = "table__changeOwner",
  Share = "table__share",
  Move = "table__move",
}

interface Props {
  currentModal: TableModal | undefined;
  currentTable: HydratedTable | undefined;
  setCurrentTable: (table?: HydratedTable | undefined) => void;
  setCurrentModal: (modal?: TableModal | undefined) => void;
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function TableModals({
  currentModal,
  currentTable,
  setCurrentTable,
  setCurrentModal,
  folderId,
}: Props) {
  const handleCloseModal = () => {
    setCurrentModal();
    setCurrentTable(undefined);
    setNewOwner(undefined);
  };

  const [newOwner, setNewOwner] = useState<Member | undefined>();

  const assetIds = useMemo(() => {
    if (!currentTable?.id) {
      return;
    }
    return [convertToAssetId(AssetTypes.Table, currentTable.id)];
  }, [currentTable?.id]);

  return (
    <>
      <TableDeleteModal
        isOpen={currentModal === TableModal.Delete}
        onClose={handleCloseModal}
        table={currentTable}
        folderId={folderId}
      />

      <TableRenameModal
        table={currentTable}
        isOpen={currentModal === TableModal.Rename}
        onCloseModal={handleCloseModal}
        folderId={folderId}
      />

      <TableChangeOwnerModalContainer
        table={currentTable}
        isOpen={currentModal === TableModal.ChangeOwner}
        onCloseModal={handleCloseModal}
        preselectedUser={newOwner}
        folderId={folderId}
      />

      <TableShareModal
        currentTable={currentTable}
        isOpen={currentModal === TableModal.Share}
        onCloseModal={handleCloseModal}
        onChangeOwner={(newOwner) => {
          setNewOwner(newOwner);
          setCurrentModal(TableModal.ChangeOwner);
        }}
      />

      <MoveAssetModal
        assetType={AssetTypes.Table}
        assetIds={assetIds}
        assetTitle={currentTable?.name}
        assetParentId={folderId}
        isOpen={currentModal === TableModal.Move}
        setIsOpen={handleCloseModal}
      />
    </>
  );
}
